/** Add badge kinds here to define their priority for every avatar surface. */
export const AVATAR_BADGE_PRIORITY = ['trust-circle', 'ambassador', 'super-sharer'] as const;
export type AvatarBadgeKind = (typeof AVATAR_BADGE_PRIORITY)[number];

export function selectAvatarBadge({
  isInTrustCircle,
  isAmbassador,
  isSuper,
}: {
  isInTrustCircle?: boolean;
  isAmbassador?: boolean | null;
  isSuper?: boolean | null;
}): AvatarBadgeKind | null {
  const eligible: Record<AvatarBadgeKind, boolean> = {
    'trust-circle': Boolean(isInTrustCircle),
    ambassador: Boolean(isAmbassador),
    'super-sharer': Boolean(isSuper),
  };
  return AVATAR_BADGE_PRIORITY.find((kind) => eligible[kind]) ?? null;
}
